import React from 'react';
import { useHasPermission } from '@lib/hooks/useHasPermission';

type Props = {
    permission: string;
    mode: "any" | "all";
    children: React.ReactNode;
    fallback?: React.ReactNode;
};

export const WithPermission = ({ permission, children, mode, fallback = null }: Props) => {
    const hasPermission = useHasPermission(permission, mode);
    return <>{hasPermission ? children : fallback}</>;
};